/**
 * @fileoverview Barrel exports for the prose-continuer-guided agent.
 *
 * Guided continuation: advances the story within a planned chapter structure.
 */

// Agent definition
export { definition } from './definition';

// Schemas and types
export {
  InputSchema,
  OutputSchema,
  type Input,
  type Output,
} from './schema';

// Flow
export { flow, proseContinuerGuidedAgentFlow } from './flow';

// Prompt template
export { prompt } from './prompt';
